import React, {FC, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {MaterialReactTable} from 'material-react-table';
import {Typography} from '@mui/material';

interface DealerListProps {
  isLoading: boolean;
  dealers: OverviewDealer[];
}

export const DealerList: FC<DealerListProps> = ({isLoading, dealers}) => {
  const navigate = useNavigate();

  const columns = useMemo(
      () => [
        {accessorKey: 'id', header: 'ID'},
        {accessorKey: 'name', header: 'Name'},
        {accessorKey: 'country', header: 'Country'},
        {accessorKey: 'printers_total', header: 'Total Printers'},
        {accessorKey: 'printers_gtx', header: 'GTX'},
        {accessorKey: 'printers_gtxpro', header: 'GTXpro'},
        {accessorKey: 'printers_gtxprobulk', header: 'GTXpro Bulk'},
        {accessorKey: 'printers_gt3', header: 'GT-3'},
      ],
      [],
  );

  const data = useMemo(
      () =>
      isLoading ?
        [] :
        dealers.map((dealer) => ({
          id: dealer.id ?? '',
          name: dealer.name ?? '',
          country: dealer.country ?? '',
          printers_total: dealer.printers_total ?? 0,
          printers_gtx: dealer.printers_gtx ?? 0,
          printers_gtxpro: dealer.printers_gtxpro ?? 0,
          printers_gtxprobulk: dealer.printers_gtxprobulk ?? 0,
          printers_gt3: dealer.printers_gt3 ?? 0,
        })),
      [dealers, isLoading],
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      enableSorting
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      muiTableBodyRowProps={({row}) => ({
        onClick: () => navigate(`/dealer/${row.original?.id}`),
        style: {cursor: 'pointer'},
      })}
      renderTopToolbarCustomActions={() =>
        <Typography variant="h6">Dealers</Typography>
      }
    />
  );
};
